import React, { useState } from 'react';
import { motion } from 'framer-motion';
import PerformanceChart from '../components/Analytics/PerformanceChart';
import ConversionFunnel from '../components/Analytics/ConversionFunnel';
import EngagementMetrics from '../components/Analytics/EngagementMetrics';
import ReportFilters from '../components/Analytics/ReportFilters';
import SafeIcon from '../common/SafeIcon';
import { FiCalendar, FiDownload } from 'react-icons/fi';


const Analytics = () => {
  const [dateRange, setDateRange] = useState('30d');
  const [campaignType, setCampaignType] = useState('all');

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Analytics</h1>
          <p className="text-gray-600">
            Track performance and optimize your campaigns
          </p>
        </div>

        <div className="flex gap-3">
          <div className="flex items-center gap-2">
            <SafeIcon icon={FiCalendar} className="text-gray-400" />
            <select
              value={dateRange}
              onChange={(e) => setDateRange(e.target.value)}
              className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="7d">Last 7 days</option>
              <option value="30d">Last 30 days</option>
              <option value="90d">Last 90 days</option>
              <option value="1y">Last year</option>
            </select>
          </div>
          
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
            <SafeIcon icon={FiDownload} className="text-sm" />
            Export Report
          </button>
        </div>
      </div>

      {/* Filters */}
      <ReportFilters 
        campaignType={campaignType}
        setCampaignType={setCampaignType}
      />

      {/* Engagement Metrics */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        <EngagementMetrics />
      </motion.div>

      {/* Charts Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2 }}
        >
          <PerformanceChart dateRange={dateRange} />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.3 }}
        >
          <ConversionFunnel />
        </motion.div>
      </div>
    </div>
  );
};

export default Analytics;